<template>
    <div>

        <v-row class="mx-4">

            <v-alert
                outlined
                dense
                type="info"
                border="left">
                If there are only exclude rules, then all carriers/services except those are included. If there are any includes, only those will be included.
            </v-alert>

            <v-col lg="5" md="12">
                <v-switch
                    class="d-inline-block"
                    v-model="shippingOption.carriers_ungrouped"
                    @change="updateCarriersUngrouped"
                    label="Return all carriers ungrouped">
                </v-switch>
            </v-col>
            <v-col lg="7" md="12">
                <CarrierServiceSelect
                    ref="post"
                    @change="$emit('save-shipping-option')"
                    @save-carrier-service="saveCarrierService('post')"
                    :integration_id="shippingOption.integration_id">
                        <template v-slot:additional-actions="slotProps">
                            <v-btn
                                color="primary"
                                @click="saveCarrierService('post')"
                                :disabled="slotProps.isLoading || slotProps.isRefreshing || slotProps.disableAddBtn"
                                >
                                Add Carrier / Service
                            </v-btn>
                        </template>
                </CarrierServiceSelect>
            </v-col>

            <v-col cols="12" v-if="selectedCarriers.length > 0">
                <v-spacer></v-spacer>
                <v-btn
                    x-small
                    class="white--text"
                    color="#FF7033" @click="deleteItem(selectedCarriers)">
                    Delete Selected
                </v-btn>
            </v-col>
        </v-row>

        <v-card elevation="0">
            <v-card-text>

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th width="40"></th>
                            <th v-if="carriers.length > 1" width="40">
                                <v-checkbox
                                    v-model="selectAll" @change="toggleAll"
                                    class="ma-0 pa-0"
                                    hide-details
                                    dense
                                    >
                                </v-checkbox>
                            </th>
                            <th>Carrier</th>
                            <th>Service</th>
                            <th>Rule</th>
                            <th width="200">Actions</th>
                        </tr>
                    </thead>
                    <TableBody
                        :sortEndpoint="baseUrl+'/sort'"
                        :items="carriers"
                        @reordered="carriers = $event"
                        >
                        <template v-slot:default="{ item }">
                            <td style="cursor: move">
                                <v-icon>mdi-drag</v-icon>
                            </td>
                            <td v-if="carriers.length > 1">
                                <v-checkbox
                                    v-model="selectedCarriers"
                                    :value="item.id"
                                    class="ma-0 pa-0"
                                    hide-details
                                    dense
                                    >
                                </v-checkbox>
                            </td>
                            <td><span>[{{ item.carrier_id }}] {{ item.carrier_name }}</span></td>
                            <td><span>[{{ item.service_id }}] {{ item.service_name }}</span></td>
                            <td>
                                {{ item.exclude ? 'Exclude' : 'Include' }}
                                <template v-if="item.condition_count > 0">
                                    with {{ item.condition_count > 1 ? 'conditions' : 'condition' }}
                                </template>
                            </td>
                            <td>
                                <v-btn x-small @click="editCarrierService(item)">Edit</v-btn>
                                <v-btn x-small class="white--text" color="#FF7033" @click="deleteItem(item)">Delete</v-btn>
                            </td>
                        </template>
                    </TableBody>
                </table>
            </v-card-text>

        </v-card>

        <!-- Add/Edit Dialog -->
        <v-dialog v-model="updateFormDialog" max-width="80%">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Edit Carrier / Service</span>
                </v-card-title>
                <v-card-text>
                    <v-container fluid class="mt-4">
                        <CarrierServiceSelect
                            ref="put"
                            :key="carrier.id + '-select'"
                            :integration_id="shippingOption.integration_id"
                        />
                        <Conditions :key="carrier.id + '-conditions'" :conditions="carrier.conditions">
                            <template v-slot:additional-conditions>
                                <v-radio-group
                                    v-model="carrier.exclude"
                                    row
                                >
                                    <v-radio
                                        label="Include"
                                        :value="false"
                                    ></v-radio>
                                    <v-radio
                                        label="Exclude"
                                        :value="true"
                                    ></v-radio>
                                </v-radio-group>
                            </template>
                        </Conditions>
                    </v-container>
                </v-card-text>
                <v-card-actions class="sticky-bottom white pb-4">
                    <v-spacer></v-spacer>
                    <v-btn small  @click="updateFormDialog=false">Close</v-btn>
                    <v-btn :disabled="isSaving" small color="primary" @click="saveCarrierService('put')">
                        <span v-if="isSaving">
                            <v-progress-circular
                                indeterminate
                                size="12"
                                width="2"
                                color="primary darken-3">
                            </v-progress-circular>
                            Saving...
                        </span>
                        <span v-else>Save</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <ConfirmationDialog
            ref="updateConfirmation"
            @on-cancel="shippingOption.carriers_ungrouped = selectedShippingOption.carriers_ungrouped"
        />

        <ConfirmationDialog
            action="delete"
            requestMethod="post"
            ref="deleteConfirmation"
            @post-confirm="postDelete"
        />

    </div>
</template>


<script>
import { EventBus } from '@/js/event-bus.js'
import { ShippingOptionStruct, ShippingOptionCarrierStruct } from './ShippingOptionStruct.js';
import CarrierServiceSelect from './components/CarrierServiceSelect';
import ConfirmationDialog from './components/ConfirmationDialog';
import Conditions from './components/Conditions';
import TableBody from './components/TableBody';
import { isArray } from 'lodash';
import store from '@/js/store/index.js';
export default {

    components: {
        CarrierServiceSelect,
        ConfirmationDialog,
        TableBody,
        Conditions,
    },

    props: {
        selectedShippingOption: {
            type: ShippingOptionStruct,
            required: true
        }
    },

    data() {
        return {
            baseUrl: `/api/shipping-options/${this.selectedShippingOption.id}/carriers`,
            shippingOption: this.selectedShippingOption,
            isLoading: false,
            isSaving: false,
            updateFormDialog: false,
            carriers: [],
            carrier: new ShippingOptionCarrierStruct({}),

            selectAll: false,
            selectedCarriers: [],
            deletedItems: []
        };
    },

    created() {
        this.initialize();
    },

    watch: {
        selectedCarriers(val) {
            // Update "Select All" checkbox based on selection
            this.selectAll = this.carriers.length > 0 && val.length === this.carriers.length;
        }
    },

    methods: {
        initialize() {
            this.isLoading = true;
            this.fetchCarriers();
        },

        toggleAll() {
            if (this.selectAll) {
                this.selectedCarriers = this.carriers.map(item => item.id);
            } else {
                this.selectedCarriers = [];
            }
        },

        editCarrierService(carrier) {
            this.carrier = new ShippingOptionCarrierStruct(carrier);
            this.updateFormDialog = true;

            // pre populate the select components
            this.$nextTick(() => {
                this.$refs.put.shippingOptionCarrier = this.carrier;
            });
        },

        fetchCarriers() {
            this.$http
                .get(`${this.baseUrl}`)
                .then(({ data }) => {
                    this.carriers = data.data.map(carrier => {
                        return new ShippingOptionCarrierStruct(carrier);
                    }) ?? [];
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        saveCarrierService(method) {

            const url = method == 'put' ? `${this.baseUrl}/${this.carrier.id}` : this.baseUrl;

            const selectedCarrier = this.$refs[method].selectedCarrier;
            const selectedService = this.$refs[method].selectedService;

            let order = method == 'put' ? this.carrier.order : this.carriers.length ? Math.max(...this.carriers.map(c => c.order ?? 0)) + 1 : 1;

            let payload;
            if(method == 'put') {
                payload = {
                    carrier_id: selectedCarrier.id,
                    carrier_name: selectedCarrier.name,
                    service_id: selectedService.id,
                    service_name: selectedService.name,
                    conditions: this.carrier.conditions, // send as is
                    exclude: this.carrier.exclude ? 1 : 0,
                    order: order
                };
            } else {

                // for create, we may need to create multiple entries if "All Carriers" is selected
                payload = [];
                if(selectedCarrier.id == 0) {
                    // if "All Carriers" is selected, we need to add all carriers as each row
                    this.$refs[method].carrierOptions.forEach(c => {
                        if(c.id == 0 || c.service_id == "") return; // skip "All Carriers" option
                        payload.push({
                            carrier_id: c.id,
                            carrier_name: c.name,
                            service_id: 0,
                            service_name: "All Services",
                            conditions: [], // send as is
                            exclude: 0,
                            order: order
                        });

                        order++;
                    });


                } else {
                    payload.push({
                        carrier_id: selectedCarrier.id,
                        carrier_name: selectedCarrier.name,
                        service_id: selectedService.id,
                        service_name: selectedService.name,
                        conditions: this.carrier.conditions, // send as is
                        exclude: this.carrier.exclude ? 1 : 0,
                        order: order
                    });
                }
            }


            this.isSaving = true;
            this.$http
                .withClientId(store.getters['LRSettingsState/getShopifyUserId'])
                [method](url, payload)
                .then(({ data }) => {
                    this.fetchCarriers();
                    this.isSaving = false;
                    this.updateFormDialog = false;
                    EventBus.$emit('show-success', 'Carrier and service updated successfully.');
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    //reset selected carrier/service on create
                    if(method != 'put') {
                        this.$refs[method].selected_carrier = "";
                    }
                    this.isLoading = false;
                });
        },

        deleteItem(item) {
            const endpoint = `/api/shipping-options/${this.selectedShippingOption.id}/carriers/delete`;
            const itemsToDelete = [];
            if(isArray(item)) {
                this.$refs.deleteConfirmation.itemLabel = `${this.selectedCarriers.length} Selected carriers`;
                itemsToDelete.push(...this.selectedCarriers);
            } else {
                itemsToDelete.push(item.id);
                this.$refs.deleteConfirmation.itemLabel = `${item.carrier_name} - ${item.service_name}`;
            }

            this.$refs.deleteConfirmation.open(endpoint, {carrier_ids: itemsToDelete});
            this.deletedItems = itemsToDelete;
        },

        postDelete() {
            this.carriers = this.carriers.filter(c => !this.deletedItems.includes(c.id));
            this.selectedCarriers = [];
            this.deletedItems = [];
        },

        updateCarriersUngrouped() {
            this.$refs.updateConfirmation.itemLabel = `Return carriers ungrouped`;
            const endpoint = `/api/shipping-options/${this.shippingOption.integration_id}/${this.shippingOption.id}`;
            const data = { id: this.shippingOption.id, carriers_ungrouped: this.shippingOption.carriers_ungrouped, statusUpdate: true };
            this.$refs.updateConfirmation.open(endpoint, data);
        }

    },

}
</script>
